<template>
    <div>
         <span v-if="loading"><i class="far fa-circle-notch fa-spin"></i> Récupération des données en cours</span>
          <span v-if="!loading && this.chart.datasets.length == 0" class="ix-text-secondary ix-text-small">Nous ne trouvons pas de données à vous afficher</span>

        <div v-if="!loading && this.chart.datasets.length > 0">
            <custom-chart  type="pie" :datasets="chart.datasets" :labels="chart.labels" :options="chart.options"></custom-chart>
        </div>
    </div>
</template>

<script>

import CustomChart from '../CustomChart.vue';

export default {
    props: {
        route: String,
    },
    components: {
        CustomChart,
    },
    data(){
        return {
            loading: true,
             chart: {
                    options: {
                        plugins: {
                            legend: {
                                display: true,
                            },
                            label: {
                                render: 'percentage', // Utiliser le rendu 'percentage' pour afficher les valeurs en pourcentage
                                precision: 0, // Précision du pourcentage (0 pour arrondir à l'entier)
                                value: {
                                    display: true,
                                    font: {
                                    weight: 'bold'
                                    }
                                }
                            },
                            tooltip: {
                                callbacks: {
                                   label: (context) => {
                                        
                                        return context.label + ' : ' + context.formattedValue + '%'
                                        // Personnaliser le format du label dans le tooltip
                                    }
                                },
                            },
                          
                        },
                        datasets: {
                            pie: {
                                clip: {left: 5, top: false, right: -2, bottom: 0}
                            }
                        },
                    },
                    labels: [],
                    datasets: []
                }
        };
    },
     methods: {
        getData : async function(){
                fetch(this.route, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    this.chart.labels = data.labels
                    data.datasets.forEach(dataset => {
                        this.chart.datasets.push(dataset)
                    })
                    this.loading = false
                }).catch(error => {
                    console.log(error)
                });
            },
    },
    async mounted(){
        await this.getData();
    }
}
</script>

<style lang="scss">
  
</style>